import React from "react";
import { ActionContext } from "views/logic/ActionContext";
import ExtractorUtils from "util/ExtractorUtils";
import Select from "components/common/Select";
import { BootstrapModalForm } from "components/bootstrap";
const _renderOption = ({ label }) => /* @__PURE__ */ React.createElement("strong", null, label);
const _getExtractorTypes = () => ExtractorUtils.EXTRACTOR_TYPES.map((extractorType) => ({
  label: ExtractorUtils.getReadableExtractorTypeName(extractorType),
  value: extractorType
}));
class SelectExtractorType extends React.Component {
  constructor(props) {
    super(props);
    this.extractorRoutes = {};
    this._onSubmit = () => {
      const { onClose } = this.props;
      onClose();
      const { selectedExtractor } = this.state;
      if (selectedExtractor) {
        const uri = this.extractorRoutes[selectedExtractor];
        const newWindow = window.open(uri, "_blank");
        newWindow.focus();
      }
    };
    this._onChange = (selectedExtractor) => {
      this.setState({ selectedExtractor });
    };
    this.state = {
      selectedExtractor: void 0
    };
  }
  componentDidMount() {
    const { message } = this.context;
    const { gl2_source_node, gl2_source_input } = message.fields;
    const { field } = this.props;
    this.extractorRoutes = ExtractorUtils.getNewExtractorRoutes(
      gl2_source_node,
      gl2_source_input,
      field,
      message.index,
      message.id
    );
  }
  render() {
    const { selectedExtractor } = this.state;
    return /* @__PURE__ */ React.createElement(
      BootstrapModalForm,
      {
        title: "Select extractor type",
        submitButtonDisabled: !selectedExtractor,
        show: true,
        onCancel: this.props.onClose,
        onSubmitForm: this._onSubmit
      },
      /* @__PURE__ */ React.createElement(
        Select,
        {
          placeholder: "Select extractor type",
          optionRenderer: _renderOption,
          clearable: true,
          onChange: this._onChange,
          options: _getExtractorTypes()
        }
      )
    );
  }
}
SelectExtractorType.contextType = ActionContext;
export default SelectExtractorType;
